// src/edaadConfig.ts

export const EDAAD_CONFIG = {
  // Social Media & Distractions
  ENABLE_STORIES: false,
  ENABLE_CONTACTS: false,

  // Content Creation (restricted to Edaad Admin)
  ENABLE_NEW_GROUPS: false, // عطلنا إنشاء المجموعات
  ENABLE_NEW_CHANNELS: true, // فعلنا إنشاء القنوات للبث
  ENABLE_NEW_PRIVATE_CHATS: false, // عطلنا المحادثات الخاصة مؤقتاً لتخصيص الأيقونة للبث فقط

  // UI Elements
  ENABLE_CALLS_TAB: false,
  ENABLE_SETTINGS_TAB: true, // Keep settings for now, but we can clean it later

  // Chat Filtering
  ENABLE_CHAT_WHITELIST: true,
  // أضف هنا المعرفات (ID)، أو اسم المستخدم (username بدون @)، أو اسم القناة حرفياً.
  ALLOWED_CHAT_IDS: ['-1003921512849'],
};

export function isEdaadEmbedMode(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('edaad_embed');
}

export function getEdaadEmbedPeer(): string | null {
  if (typeof window === 'undefined') return null;
  return new URLSearchParams(window.location.search).get('peer');
}

export function getEdaadEmbedRole(): 'teacher' | 'student' {
  if (typeof window === 'undefined') return 'student';
  const role = new URLSearchParams(window.location.search).get('role');
  return role === 'teacher' ? 'teacher' : 'student';
}
